var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7953 15.3086L6.39763 9.01241L8.53018 6.91368L14.9278 13.2099L21.3254 6.91368L23.458 9.01241L17.0604 15.3086L23.458 21.6048L21.3254 23.7035L14.9278 17.4073L8.53018 23.7035L6.39763 21.6048L12.7953 15.3086Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.7621C29 22.3478 22.7471 28.5243 15 28.5243C7.25288 28.5243 1 22.3478 1 14.7621C1 7.17653 7.25288 1 15 1C22.7471 1 29 7.17653 29 14.7621Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotApprovedIcon);
export default __webpack_public_path__ + "static/media/not-approved-icon.de6cb42f1365e56bdef911ed5ff0636c.svg";
export { ForwardRef as ReactComponent };